import { IMAInterest } from "../types/MAInterest";

export const initialMainterest: IMAInterest = {
    opportunity: "",
    lifecycle: [],
    software_solution: [],
    featured_solution: [],
    targeted_industry:  [],
    isvBased: [],
    ecosystem: [],
    have_technology:null,
};